<template>
  <!-- 模型 -->
  <div class="model" id="standAlone-model">
    <!-- title -->
    <div class="model-head">
      <div class="head-title">{{ AloneData.machineName }}</div>
      <!-- 设备信息 -->
      <!-- :infoData="infoList" -->
      <info v-show="isEdit === false" :infoData="infoList"></info>
    </div>
    <div class="switch" v-show="isEdit === false">
      <div class="switch-left" @click="switchLeftFn"></div>
      <div class="switch-right" @click="switchRightFn"></div>
    </div>
  </div>
</template>
<script>
import info from "@/module/info.vue";
import ThreeDimensional from "@/assets/three/ThreeDimensional";
// api接口
import { MTypeQuery } from "@/assets/api/chartData";
import { machineStatus} from "@/assets/api/feedingStyle";

var ThreeDimen;

export default {
  components: {
    info,
  },
  props: ["isContEdit", "standAloneData"],
  data() {
    return {
      // 设备信息
      infoList: [
        {
          infoName: "设备名称",
          infoData: "上料系统",
        },
        {
          infoName: "设备型号",
          infoData: "ZK003",
        },
        {
          infoName: "设备状态",
          infoData: "运行中",
        },
        {
          infoName: "产能效率",
          infoData: "60/500",
        },
      ],
      modelIndex: 0,
      isEdit: false,
      AloneData: {},
      cMType: 1,
      getDataInterval: null,
      test : 111
      
    };
  },
  created() {
    //获取统计分析页面的头部标题栏
    this.getQuery();
  },
  mounted() {
    window.ClearScene_Model = this.ClearScene_Model;
    this.getDataInterval = setInterval(() => {
      this.getQuery();
    }, 2000);
    this.modelIndex = this.$store.state.modelIndex;
    this.$nextTick(() => {
      this.getcMType();
      //this.getMachineStatus();
    });
  },
  methods: {
    getQuery() {
      //  获取统计分析页面的头部标题栏
      this.AloneData = this.$store.state.data;
      //                      设备名称        设备状态        设备型号        产能效率
      const selectedList = ["machineName", "deviceStatus", "deviceModel","capacityEfficiency"];
      const _selectedList = [];
      selectedList.map((filedKey) => {
        const data = this.AloneData.chartVoList.find((item) => {
          return item.filedKey == filedKey;
        });
        if (data) _selectedList.push(data);
      });
      this.infoList = _selectedList;
      //把产能效率和vlue值拼接在一起
      let updateData = this.infoList[3].value +  this.infoList[3].filedUnit;
      this.infoList[3].filedUnit = updateData;
      this.$store.commit("infoListUpdate",_selectedList);
    },
    switchLeftFn() {
      this.$store.commit("flagUpdate",3);
      this.$bus.emit("switch", true);
      let i = --this.modelIndex;
      ThreeDimen.ChangeModel(this.ChangeModelIndex(i));
      ThreeDimen.ChangeModelData(this.cMType);
    },
    switchRightFn() {
      this.$store.commit("flagUpdate",3);
      this.$bus.emit("switch", true);
      let i = ++this.modelIndex;
      ThreeDimen.ChangeModel(this.ChangeModelIndex(i));
      ThreeDimen.ChangeModelData(this.cMType);
    },
    ChangeModelIndex(i) {
      if (i > 14) {
        this.modelIndex = 0;
      } else if (i < 0) {
        this.modelIndex = 14;
      }
      this.$store.commit("incrementFive", this.modelIndex);
      return this.modelIndex;
    },
    //查询是否卷绕机
    getcMType() {
      MTypeQuery().then(res => {
        this.cMType = res.data[0].machineCategory;
        //this.cMType == 1 叠片机
        //this.cMType == 0 卷绕机
        ThreeDimen = new ThreeDimensional("standAlone-model", true,this.modelIndex,this.cMType); 
        this.getMachineStatus();
      })
    },
    ClearScene_Model(){
      if (ThreeDimen) {
        ThreeDimen.clearScene();
      }
    },
    async getMachineStatus() {
      let { data } = await machineStatus();
      this.Machindata = data;
      window.animaType = this.Machindata;
      ThreeDimen.getMachineMove();
      //console.log(this.Machindata);
    }
  },
  
  beforeDestroy() {
    ThreeDimen.clearScene();
  },
  watch: {
    isContEdit(n) {
      this.isEdit = n;
    },
  },
  destroyed() {
    //清除定时器
    if (this.getDataInterval) clearInterval(this.getDataInterval);
  }
};
</script>
<style lang="less" scoped>
.model {
  display: flex;
  flex-direction: column;
  align-items: center;

  .model-head {
    width: 850px;
    /* 文字不可选取 */
    user-select: none;
    position: fixed;
    top: 100px;
    left: 560px;
    // 画布穿透
    // pointer-events: none;

    .head-title {
      width: 100%;
      height: 40px;
      background: url("./images/model-title.png") no-repeat 0 0;
      background-size: 100% 100%;
      font-size: 26px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    }

    .head-info {
      width: 100%;
      height: 70px;
      margin-top: 12px;
      user-select: text;
    }
  }

  .switch {
    // width: calc(100% - 1050px);
    // position: fixed;
    // top: 500px;
    // left: 550px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;

    .switch-left {
      position: fixed;
      top: 500px;
      left: 500px;
      width: 45px;
      height: 70px;
      background: url("./images/switch-left.png") no-repeat 0 0;
      background-size: 100% 100%;
      cursor: pointer;
    }

    .switch-right {
      position: fixed;
      top: 500px;
      right: 500px;
      width: 45px;
      height: 70px;
      background: url("./images/switch-right.png") no-repeat 0 0;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}
#standAlone-model {
  width: 100px;
  height: 100%;
}
</style>